import React from "react";
import { useTranslation } from "react-i18next";
import { Page } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import SeoTemplateSkeleton from "./SeoTemplate/Skeleton";
import TabContainer from "../../components/components/TabContainer";

export default function SeoTemplatesSkeleton(props) {
  const { t } = useTranslation();
  
  return (
    <TabContainer
      sections={[
        {
          title: t("seoTemplates.title"),
          items: [
            {
              label: t("themes.templates.items.location"),
              url: "/seo-templates/location",
            },
            {
              label: t("themes.templates.items.city"),
              url: "/seo-templates/city",
            },
            ,
            {
              label: t("themes.templates.items.region"),
              url: "/seo-templates/region",
            },
            {
              label: t("themes.templates.items.country"),
              url: "/seo-templates/country",
            },
            {
              label: t("themes.templates.items.directory"),
              url: "/seo-templates/directory",
            },
            {
              label: t("themes.templates.items.landing"),
              url: "/seo-templates/landing",
            },
          ],
        },
      ]}
    >
      <TitleBar
        title={t("seoTemplates.title")}
        primaryAction={{ content: "Save", loading: true }}
      />
      <Page>
        <SeoTemplateSkeleton />
      </Page>
    </TabContainer>
  );
}
